import React from "react";
import { Modal, Timeline, Tag, Typography, Empty } from "antd";
import {
  CheckCircleFilled,
  WarningFilled,
  UserOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import moment from "moment";

const { Text } = Typography;

// Dummy data for testing

export function ViewOrderCorrectionRequest({
  open,
  onClose,
  OrderCorrectionData = [],
}) {
  // Reverse the array to show in reverse order (oldest first for timeline)
  const reversedCorrections = [...OrderCorrectionData].reverse();
  const getTimelineIcon = (isResolved) => {
    return isResolved ? (
      <CheckCircleOutlined style={{ fontSize: "20px", color: "#52c41a" }} />
    ) : (
      <WarningFilled style={{ fontSize: "20px", color: "#faad14" }} />
    );
  };

  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <HistoryOutlined style={{ fontSize: "18px", color: "#1890ff" }} />
          <span>Correction Request History</span>
        </div>
      }
      visible={open}
      onCancel={onClose}
      footer={null}
      width={800}
      bodyStyle={{
        maxHeight: "70vh",
        overflowY: "auto",
        padding: "16px 20px",
      }}
    >
      {OrderCorrectionData.length === 0 ? (
        <Empty description="No correction requests found" />
      ) : (
        <Timeline mode="left">
          {reversedCorrections.map((correction, index) => (
            <Timeline.Item
              key={correction._id || index}
              dot={getTimelineIcon(correction.isResolved)}
            >
              <div
                style={{
                  background: correction.isResolved ? "#f6ffed" : "#fffbe6",
                  padding: "10px 12px",
                  borderRadius: "8px",
                  border: `1px solid ${
                    correction.isResolved ? "#b7eb8f" : "#ffe58f"
                  }`,
                  marginBottom: "4px",
                }}
              >
                {/* Header Row */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <Tag
                    color={correction.isResolved ? "success" : "warning"}
                    style={{ margin: 0, fontSize: "14px", fontWeight: "bold" }}
                  >
                    {correction.isResolved ? "Resolved" : "Pending"}
                  </Tag>
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    <CalendarOutlined style={{ marginRight: "4px" }} />
                    {moment(correction.raisedDate).format(
                      "DD MMM YYYY, hh:mm A"
                    )}
                  </Text>
                </div>

                {/* Reasons - Inline */}
                <div style={{ marginBottom: "6px" }}>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}
                  >
                    {correction.reasons?.map((reason, idx) => (
                      <Tag
                        key={idx}
                        color="error"
                        style={{
                          fontSize: "14px",
                          margin: 0,
                          fontWeight: "600",
                        }}
                      >
                        {reason}
                      </Tag>
                    ))}
                  </div>
                </div>

                {/* Remark - Compact */}
                {correction.remark && (
                  <div style={{ marginBottom: "6px" }}>
                    <Text
                      strong
                      style={{ fontSize: "13px", marginRight: "6px" }}
                    >
                      Remark:
                    </Text>
                    <Text style={{ fontSize: "13px", color: "#595959" }}>
                      {correction.remark}
                    </Text>
                  </div>
                )}

                {/* Footer - Raised By & Resolved Info */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderTop: "1px dashed #d9d9d9",
                    paddingTop: "6px",
                    marginTop: "2px",
                  }}
                >
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    <UserOutlined style={{ marginRight: "4px" }} />
                    <Text strong style={{ fontSize: "12px", color: "#8c8c8c" }}>
                      Raised by:{" "}
                    </Text>
                    {correction.raisedBy?.firstName}{" "}
                    {correction.raisedBy?.lastName}
                  </Text>
                  {correction.isResolved && correction.resolvedBy && (
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      <CheckCircleFilled
                        style={{ marginRight: "4px", color: "#52c41a" }}
                      />
                      <Text
                        strong
                        style={{ fontSize: "12px", color: "#8c8c8c" }}
                      >
                        Resolved by:{" "}
                      </Text>
                      {correction.resolvedBy?.firstName}{" "}
                      {correction.resolvedBy?.lastName} •{" "}
                      {moment(correction.resolvedDate).format("DD MMM YYYY, hh:mm A")}
                    </Text>
                  )}
                </div>
              </div>
            </Timeline.Item>
          ))}
        </Timeline>
      )}
    </Modal>
  );
}
